export default "__VITE_ASSET__B_9aflN8__"